export default {
    baseStyle: ({theme}) => ({
        container: {
            backgroundColor: 'stokkeCore.white'
        },
        aspectContainer: {
            width: {base: '70px', lg: '90px'}
        },
        imageOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            backgroundImage: theme.gradients.greyBackgroundOfProductImages
        }
    }),
    variants: {
        order: {
            aspectContainer: {
                width: 20
            }
        }
    },
    parts: ['container', 'aspectContainer', 'imageOverlay']
}
